import React from "react";
import { Button, ButtonProps } from "../components/Button";
import { Dump } from "../components/Dump";
import { MaxWidth } from "../layouts/MaxWidth";
import styles from "./CtaSection.module.css";

export type CtaSectionProps = {
  title: string;
  text: string;
  button: ButtonProps;
};

export const CtaSection = ({ title, text, button }: CtaSectionProps) => {
  return (
    <section className={styles.container}>
      <MaxWidth size="sm">
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.text}>{text}</p>
        <div className={styles.buttonWrapper}>
          <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 56 114"
            width="56"
            height="114"
            className={styles.sparkle}
          >
            <path
              d="M6.854 58.008c-1.315-.249-2.298-.379-3.252-.638-1.887-.51-3.744-2.665-3.593-4.262.22-2.235 1.716-3.713 3.734-4.132 5.651-1.157 11.202-.369 16.582 1.607 1.185.43 1.355 2.475.281 3.284-.783.589-1.535 1.397-2.429 1.626-3.834.968-7.729 1.737-11.323 2.515ZM56 105.475c-.2 1.847-.28 4.172-.772 6.398-.291 1.297-1.516 2.096-2.992 2.125-1.475.04-2.54-.708-3.222-1.916-1.405-2.465-.923-5.18-.692-7.764.23-2.615.853-5.2 1.435-7.765.331-1.437 1.536-2.316 2.911-2.156 1.355.16 2.309 1.317 2.49 2.715.34 2.635.541 5.259.843 8.363ZM27.622 31.281c-.29 1.457-.993 2.585-2.409 2.825-1.255.21-2.65.329-3.854.01-2.58-.69-4.718-2.226-6.605-4.112-2.168-2.166-2.68-4.621-1.225-5.999 1.917-1.796 3.664-.499 5.36.37 2.34 1.187 4.628 2.475 6.927 3.732 1.305.699 1.646 1.937 1.806 3.174ZM41.747 12.658c-.762 1.278-1.8 2.109-3.215 1.865-1.253-.218-2.609-.567-3.638-1.268-2.202-1.505-3.704-3.663-4.853-6.068-1.32-2.761-.982-5.247.85-6.063 2.408-1.059 3.621.744 4.93 2.125 1.808 1.896 3.536 3.869 5.283 5.817.997 1.091.905 2.371.643 3.592ZM9.725 82.49c-1.536-.468-2.74-.918-3.122-2.425-.351-1.397-.07-2.814.994-3.563 2.42-1.696 5.029-3.123 7.589-4.62 1.646-.959 3.513-2.625 5.099-.34 1.255 1.807.19 3.803-.954 5.45-2.369 3.403-5.4 5.718-9.606 5.499ZM26.338 100.066c-1.476-.3-2.299-1.258-2.43-2.685-.06-.609.121-1.387.483-1.866 2.62-3.483 6.183-5.889 9.817-8.184.341-.22 1.295.15 1.726.519.452.39.964 1.198.833 1.667-1.274 4.68-4.005 8.263-8.482 10.37-.562.259-1.305.129-1.947.179Z"
              fill="#FDC133"
            />
          </svg>
          <Button
            {...button}
            className={styles.button}
            variation="primary-diap"
          />
        </div>
      </MaxWidth>
    </section>
  );
};
